import { FormHelperText, Input, InputLabel, FormControl } from '@material-ui/core';
import { IMaskInput } from 'react-imask';
import React from 'react';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="(#00) 000-0000"
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

const PhoneInputField = props => {

    const { onChange,
        error,
        name,
        id,
        placeholder,
        value,
        label,
        disabled,
        required,
        containerStyle = {},
        onEnterPress = () => { } } = props;

    const onKeyPress = (event) => {
        event && event.key === 'Enter' && onEnterPress()
    }

    return (
        <FormControl
            style={{ height: '70px', ...containerStyle }}
            fullWidth={true}
            error={!!error}
            placeholder={placeholder}
            name={name}
            required={required}
        >
            {label && <InputLabel htmlFor={id} style={{ color: 'var(--placeholder-text)' }}>{label}</InputLabel>}
            <Input
                id={id}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                disabled={disabled}
                name={name}
                onKeyPress={onKeyPress}
                inputComponent={TextMaskCustom}
            />
            <FormHelperText id={`${id}-error-text`}>{error}</FormHelperText>
        </FormControl>
    )
}

export default (PhoneInputField);